<a
    class="article-card__container"
    [class.article-card__container--horizontal]="horizontal"
    [href]="path"
    (mouseenter)="mouseEnter()"
    (mouseleave)="mouseLeave()"
>
    @if (image) {
        <div class="article-card__container__image">
            <img
                class="article-card__container__image__img"
                [ngSrc]="image"
                height="200"
                width="200"
                alt="article card image"
                nwTint
                [tint]="imageTint"
                [id]="'image-tint-' + id"
            />
        </div>
    }
    <div
        class="article-card__container__body"
        [style.height]="horizontal ? undefined : '100%'"
    >
        @if (category) {
            <h6 class="article-card__container__body__category">{{ category }}</h6>
            <div
                class="article-card__container__body__underline"
                [style.backgroundColor]="categorycolor"
            ></div>
        }
        <h4
            class="article-card__container__body__heading"
            [class.margin-top-m]="category"
        >
            <ng-content></ng-content>
        </h4>
        <div
            class="article-card__container__body__author-and-date"
            [class.article-card__container__body__author-and-date--no-date]="
                !publishedDate
            "
            [class.article-card__container__body__author-and-date--no-avatar]="!avatar"
        >
            @if (avatar) {
                <img
                    class="article-card__container__body__author-and-date__avatar"
                    [ngSrc]="avatar"
                    [alt]="author + ' avatar'"
                    height="20"
                    width="20"
                />
            }
            <h6
                class="article-card__container__body__author-and-date__author"
                [class.padding-left-m]="avatar"
            >
                {{ author }}
            </h6>

            @if (publishedDate) {
                <p>{{ publishedDate }}</p>
            }

            @if (type) {
                <nw-pill class="article-card__container__body__author-and-date__pill">
                    <div
                        class="article-card__container__body__author-and-date__pill__content"
                    >
                        @switch (type) {
                            @case ('Article') {
                                <nw-icon>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 22"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M4.5 3.5c0-1.655 1.345-3 3-3H21c1.655 0 3 1.345 3 3v15c0 1.655-1.345 3-3 3H3.75A3.749 3.749 0 0 1 0 17.75V5c0-.83.67-1.5 1.5-1.5S3 4.17 3 5v12.75c0 .413.337.75.75.75.412 0 .75-.337.75-.75V3.5Zm3 1.125v3.75c0 .623.502 1.125 1.125 1.125h11.25C20.498 9.5 21 8.998 21 8.375v-3.75c0-.623-.502-1.125-1.125-1.125H8.625c-.623 0-1.125.502-1.125 1.125Zm0 8.625c0 .412.338.75.75.75h4.5c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm7.5 0c0 .412.338.75.75.75h4.5c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm-7.5 4.5c0 .413.338.75.75.75h4.5c.412 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm7.5 0c0 .413.338.75.75.75h4.5c.413 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Z"
                                        />
                                    </svg>
                                </nw-icon>
                            }
                            @case ('Webinar') {
                                <nw-icon>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 16"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M0 2.667A2.67 2.67 0 0 1 2.667 0h10.666A2.67 2.67 0 0 1 16 2.667v10.666A2.67 2.67 0 0 1 13.333 16H2.667A2.67 2.67 0 0 1 0 13.333V2.667Zm23.296-1.175c.433.233.704.683.704 1.175v10.666a1.334 1.334 0 0 1-2.075 1.109l-4-2.667-.592-.396V4.621l.592-.396 4-2.667c.408-.27.933-.3 1.37-.066Z"
                                        />
                                    </svg>
                                </nw-icon>
                            }
                            @case ('Infogram') {
                                <nw-icon>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 21 22"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M7.5 2.75A2.25 2.25 0 0 1 9.75.5h1.5a2.25 2.25 0 0 1 2.25 2.25v16.5a2.25 2.25 0 0 1-2.25 2.25h-1.5a2.25 2.25 0 0 1-2.25-2.25V2.75Zm-7.5 9A2.25 2.25 0 0 1 2.25 9.5h1.5A2.25 2.25 0 0 1 6 11.75v7.5a2.25 2.25 0 0 1-2.25 2.25h-1.5A2.25 2.25 0 0 1 0 19.25v-7.5ZM17.25 3.5h1.5A2.25 2.25 0 0 1 21 5.75v13.5a2.25 2.25 0 0 1-2.25 2.25h-1.5A2.25 2.25 0 0 1 15 19.25V5.75a2.25 2.25 0 0 1 2.25-2.25Z"
                                        />
                                    </svg>
                                </nw-icon>
                            }
                        }
                        <span>{{ type }}</span>
                    </div>
                </nw-pill>
            }
        </div>
    </div>
</a>
